<!-- HEADER -->
<div style="margin-bottom: 1rem;">
  <div class="header-row">
    <label class="textColour">
     {{text}}
    </label>
  </div>
</div>

<form [formGroup]="decisionForm">

  <!-- 🔷 TOP 3 FIELDS -->
  <div class="grid-2">

    <!-- Effective Date -->
    <mat-form-field appearance="outline">
      <mat-label>Effective Date</mat-label>
      <input matInput [matDatepicker]="picker" formControlName="effectiveDate">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>

      <mat-error *ngIf="decisionForm.get('effectiveDate')?.hasError('required')">
        Effective Date is required
      </mat-error>
    </mat-form-field>

    <!-- Source -->
    <mat-form-field appearance="outline">
      <mat-label>Source</mat-label>
      <mat-select formControlName="source">
        <mat-option *ngFor="let src of sourceList" [value]="src">
          {{ src }}
        </mat-option>
         <!-- Always keep Others at last -->
       <mat-option value="Others">Others</mat-option>
      </mat-select>

      <mat-error *ngIf="decisionForm.get('source')?.hasError('required')">
        Source is required
      </mat-error>
    </mat-form-field>

    <!-- Others Text Area (Shown only if Others selected) -->
<mat-form-field appearance="outline" *ngIf="decisionForm.get('source')?.value === 'Others'">
  <mat-label>Please specify source</mat-label>
  <textarea matInput formControlName="otherSource"></textarea>

  <mat-error *ngIf="decisionForm.get('otherSource')?.hasError('required')">
    Please specify the source
  </mat-error>
</mat-form-field>

<!-- <mat-form-field appearance="outline">
  <mat-label>Decision Rank (1–10)</mat-label>
  
  <input
    matInput
    type="number"
    formControlName="decisionRank"
    min="1"
    max="10"
  />

  <mat-error *ngIf="decisionForm.get('decisionRank')?.hasError('required')">
    Decision Rank is required
  </mat-error>

  <mat-error *ngIf="decisionForm.get('decisionRank')?.hasError('min')">
    Minimum value is 1
  </mat-error>

  <mat-error *ngIf="decisionForm.get('decisionRank')?.hasError('max')">
    Maximum value is 10
  </mat-error>
</mat-form-field> -->


    <!-- Empty column for alignment -->
    <div></div>

  </div>

  <!-- 🔷 DECISION SECTION -->
  <div class="two-column">

    <mat-form-field appearance="outline">
    <mat-label>Decision</mat-label>
    <input matInput formControlName="decision">
    <mat-error *ngIf="decisionForm.get('decision')?.hasError('required')">
        Decision is required
    </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Decision Description</mat-label>
      <textarea matInput rows="1" formControlName="decisionDescription"></textarea>

      <mat-error *ngIf="decisionForm.get('decisionDescription')?.hasError('required')">
        Decision Description is required
      </mat-error>
    </mat-form-field>

  </div>

  <!-- 🔷 SAFETY COMMUNICATION -->
  <div class="summary-grid">

    <div class="summary-item" style="border-bottom: 1px solid #ccc;">
      <label>Safety Communication</label>
    </div>

    <div style="margin-top: 2%;">
      <mat-checkbox formControlName="dhpc">
        DEAR Health Care Professional Communication (DHPC)
      </mat-checkbox>
    </div>

    <div>
      <mat-checkbox formControlName="dil">
        DEAR Investigator Letter (DIL)
      </mat-checkbox>
    </div>

    <div class="full">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Safety Communication Text</mat-label>
        <textarea matInput rows="3" formControlName="safetyText"></textarea>
      </mat-form-field>
    </div>

  </div>

  <!-- ACTIONS -->
  <div class="actions">

		     <app-common-button
          label="Back"
          title="Back "  
          [buttonId]="1111"
          variant="cancel"
          width="110px"
          [critical]="false"
          (clicked)="onCancel()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>

	  <app-common-button
          label="Submit"
          title="Submit "

          [buttonId]="1111"
			width="110px"
          [critical]="false"
          (clicked)="onSubmit()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
  </div>

</form>